export default __webpack_public_path__ + "static/media/shark-tank.3e7c1f8b.png";